export default __webpack_public_path__ + "static/media/home_main.0dd083c9.jpg";